var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIsotipoWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 136,
    height: 171,
    viewBox: "0 0 136 171",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.448 68.2589C8.11567 68.2589 0.515625 75.8591 0.515625 85.1914C0.515625 94.5237 8.11567 102.124 17.448 102.124H118.73C128.063 102.124 135.663 94.5237 135.663 85.1914C135.663 75.8591 128.063 68.2589 118.73 68.2589H17.448Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M68.2888 137.05C63.2169 137.05 59.253 139.204 55.6012 142.84C51.965 146.476 48.048 148.395 43.0541 148.395C38.0602 148.395 34.346 146.647 30.3821 142.684C26.4182 138.72 22.8288 137.05 17.8505 137.05C8.54935 137.05 1.02734 144.588 1.02734 153.873C1.02734 163.159 8.56495 170.696 17.8505 170.696C22.8756 170.696 26.6522 168.792 30.4445 165C34.2211 161.223 38.029 159.335 43.0541 159.335C48.0792 159.335 51.7934 161.114 55.7885 165.109C59.7836 169.104 63.3261 170.696 68.2888 170.696C77.59 170.696 85.1121 163.159 85.1121 153.873C85.1121 144.588 77.5743 137.05 68.2888 137.05Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.323 0.732178C7.95945 0.732178 0.359375 8.34786 0.359375 17.6958C0.359375 27.0437 7.97506 34.6594 17.323 34.6594H68.8382C78.2017 34.6594 85.8018 27.0437 85.8018 17.6958C85.8018 8.34786 78.1861 0.732178 68.8382 0.732178H17.323Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M118.687 34.4878C127.978 34.4878 135.51 26.9558 135.51 17.6646C135.51 8.37338 127.978 0.841339 118.687 0.841339C109.395 0.841339 101.863 8.37338 101.863 17.6646C101.863 26.9558 109.395 34.4878 118.687 34.4878Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M108.321 137.253C104.934 137.253 102.172 140.015 102.172 143.401V164.345C102.172 167.731 104.934 170.493 108.321 170.493H129.373C132.759 170.493 135.522 167.731 135.522 164.345V143.401C135.522 140.015 132.759 137.253 129.373 137.253H108.321Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIsotipoWhite);
export default __webpack_public_path__ + "static/media/isotipo_white.5498d00c7e023e6aefecc6c1f49e5fc5.svg";
export { ForwardRef as ReactComponent };